<template>
	<div class="header">
		<div class="headerMain">
			<div class="logo" v-if="menus.length">
				<img src="../../assets/images/logo.png" alt="">
			</div>
			<ul class="nav">
				<li :key="item.id" v-for="(item,index) in menus">
					<router-link :to="item.url" :class="{active:cur==index}">{{item.title}}</router-link>
				</li>
				<!--<li>-->
					<!--<router-link to="/">登录</router-link>-->
				<!--</li>-->
			</ul>
			<div class="search">
				<i class="icon"></i>
				<input type="text" placeholder="请输入关键字..." />
			</div>
		</div>
	</div>
</template>

<script>
	
	
	export default {
		props:{
			cur:{
				required:true,
				type:Number
			},
			menus:{
				required:true,
				type:Array
			}
		},
	}
</script>

<style scoped>
	.header {
		width: 100%;
		padding: 5px 0;
		box-sizing: border-box;
		background: #1C2327;
		height: 60px;
		margin-bottom: 20px;
		position: fixed;
		top: 0;
		z-index: 99;
		opacity: .95;
		box-shadow: 0 0 5px 0;
	}

	.header::before {
		background: #000 linear-gradient(to left, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
		content: "";
		height: 5px;
		position: absolute;
		top: 0;
		width: 100%;
	}

	.headerMain {
		width: 1300px;
		margin: auto;
	}

	.logo {
		float: left;
		margin-right: 60px;
		line-height: 50px;
		color: #FFF;
		font-size: 22px;
	}
	.logo img{
		width: 100%;
		height: 55px;
	}

	.nav {
		float: left;
		text-align: center;
	}

	.nav li {
		float: left;
	}

	.nav li a {
		display: inline;
		float: left;
		padding: 0 20px;
		color: #fff;
		line-height: 55px;
	}

	.search {
		float: right;
		padding: 11px 0;
		position: relative;
	}
	.search:hover input{
		opacity: 1;
	}
	.search:hover i{
		background: url(../../assets/images/search.png) no-repeat center !important;
	}
	.search input{
		padding-right: 35px;
		width: 180px;
		border: 1px solid #ccc;
		border-radius: 20px;
		color: #666;
		line-height: 30px;
		text-indent: 10px;
		transition: .5s;
		opacity: 0;
	}
	.search i{
		background: url(../../assets/images/search2.png) no-repeat center !important;
		cursor: pointer;
		width: 22px;
		position: absolute;
		height: 22px;
		background-color: red;
		top: 17px;
		right: 10px;
		z-index: 1;
	}
</style>
